<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import Table from "../../../base-components/Table";
import { numeroFormateado } from "../../../utils/helper";
import { Pedido } from "@fixeduy/restaurantestypes";
import { useMonedasDiccionarioStore } from "../../../stores/monedas";
// import { useMonedasStore } from "../../../services/monedas";
// import { useTasasIVAStore } from "../../../services/tasas";

interface Props {
  pedidos: Pedido[];
}
const props = defineProps<Props>();

const totalesPorTasasNacional = ref(
  [] as { tasa: string; importe: number; montoIVA: number }[]
);
interface MonedaInfo {
  moneda: string;
  importe: number;
  montoIVA: number;
}

interface TasaInfo {
  tasa: string;
  monedas: MonedaInfo[];
}

// Inicialización de datos
const totalesPorTasasOrigen = ref<TasaInfo[]>([]);
const importeTotalSinIVA = ref(0);
const importeIVAtotal = ref(0);

const montoTotal = ref([] as { moneda: string; importe: number }[]);
const montoIVA = ref([] as { moneda: string; importe: number }[]);
const montoSubtotal = ref([] as { moneda: string; importe: number }[]);

const hayMonedaExtranjera = ref(false);

const calcularDatos = (pedidos: Pedido[]) => {
  montoTotal.value = [];
  montoIVA.value = [];
  montoSubtotal.value = [];

  totalesPorTasasOrigen.value = [];
  totalesPorTasasNacional.value = [];
  importeTotalSinIVA.value = 0;
  importeIVAtotal.value = 0;

  for (const pedido of pedidos) {
    // const monedaActual = pedido.moneda;
    const monedaActual = "pesos";
    if (monedaActual !== "pesos") {
      hayMonedaExtranjera.value = true;
    }
    const monedaExistente = montoTotal.value.find(
      item => item.moneda === monedaActual
    );

    if (!monedaExistente) {
      // La moneda no existe, agregar totales para esa moneda
      const nuevoTotal = {
        moneda: monedaActual,
        importe: 0
      };
      const nuevoIVA = {
        moneda: monedaActual,
        importe: 0
      };
      const nuevoSubtotal = {
        moneda: monedaActual,
        importe: 0
      };

      // if (
      //   pedido.tipo === "venta" ||
      //   pedido.tipo === "notadebito"
      // ) {
      nuevoTotal.importe += pedido.total;
      nuevoIVA.importe += pedido.montoIva;
      nuevoSubtotal.importe += pedido.subtotal;
      // } else {
      //   nuevoTotal.importe -= pedido.total;
      //   nuevoIVA.importe -= pedido.montoIVA;
      //   nuevoSubtotal.importe -= pedido.subtotal;
      // }

      montoTotal.value.push(nuevoTotal);
      montoIVA.value.push(nuevoIVA);
      montoSubtotal.value.push(nuevoSubtotal);
    } else {
      // La moneda ya existe, actualizar totales
      // if (
      //   pedido.tipo === "venta" ||
      //   pedido.tipo === "notadebito"
      // ) {
      monedaExistente.importe += pedido.total;
      const monedaIVAExistente = montoIVA.value.find(
        item => item.moneda === monedaActual
      );
      if (monedaIVAExistente) {
        monedaIVAExistente.importe += pedido.montoIva;
      }
      const monedaSubtotalExistente = montoSubtotal.value.find(
        item => item.moneda === monedaActual
      );
      if (monedaSubtotalExistente) {
        monedaSubtotalExistente.importe += pedido.subtotal;
      }
      // } else {
      //   monedaExistente.importe -= pedido.total;
      //   const monedaIVAExistente = montoIVA.value.find(
      //     item => item.moneda === monedaActual
      //   );
      //   if (monedaIVAExistente) {
      //     monedaIVAExistente.importe -= pedido.montoIVA;
      //   }
      //   const monedaSubtotalExistente = montoSubtotal.value.find(
      //     item => item.moneda === monedaActual
      //   );
      //   if (monedaSubtotalExistente) {
      //     monedaSubtotalExistente.importe -= pedido.subtotal;
      //   }
      // }
    }
  }
};

onMounted(() => {
  // console.log(`PedidosListadoTotales.vue - onMounted - props.pedidos.length: ${props.pedidos.length}`);
  calcularDatos(props.pedidos);
});

watch(
  () => props.pedidos,
  (newVal, oldVal) => {
    // console.log(`PedidosListadoTotales.vue - cambio - props.pedidos.length: ${props.pedidos.length}`);
    calcularDatos(newVal);
  }
);

const monedasStore = useMonedasDiccionarioStore();
// const tasasStore = useTasasIVAStore();
const verTotalesPorTasa = ref(false);
const leyendaTotales = ref("Ver totales por tasas de IVA");

const verTotalesPorIVA = () => {
  verTotalesPorTasa.value = !verTotalesPorTasa.value;
  if (verTotalesPorTasa.value) {
    leyendaTotales.value = "Ocultar totales por tasas de IVA";
  } else {
    leyendaTotales.value = "Ver totales por tasas de IVA";
  }
};
</script>

<template>
  <div class="ms-5 me-5">
    <Table sm>
      <Table.Tr>
        <Table.Td colspan="30" class="px-0 py-0">
          <Table class="text-center">
            <Table.Tr>
              <Table.Td>
                <div
                  v-for="monto in montoSubtotal"
                  :key="monto.moneda"
                  class="monto-item"
                >
                  <b
                    >Subtotal: $
                    <!-- {{ monedasStore.getMonedaById(monto.moneda)?.simbolo }} -->

                    {{ numeroFormateado(monto.importe) }}</b
                  >
                </div>
              </Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td>
                <div
                  v-for="monto in montoIVA"
                  :key="monto.moneda"
                  class="monto-item"
                >
                  <b
                    >IVA: $
                    <!-- {{ monedasStore.getMonedaById(monto.moneda)?.simbolo }} -->
                    {{ numeroFormateado(monto.importe) }}</b
                  >
                </div>
              </Table.Td>
              <Table.Td></Table.Td>
              <Table.Td></Table.Td>
              <Table.Td>
                <div
                  v-for="monto in montoTotal"
                  :key="monto.moneda"
                  class="monto-item"
                >
                  <b
                    >Total: $
                    <!-- {{ monedasStore.getMonedaById(monto.moneda)?.simbolo }} -->
                    {{ numeroFormateado(monto.importe, 2) }}</b
                  >
                </div>
              </Table.Td>
              <Table.Td></Table.Td>
            </Table.Tr>
          </Table>
        </Table.Td>
      </Table.Tr>
      <!-- <Table.Tr>
      <Table.Td colspan="100%" style="text-align: center">
        <span @click="verTotalesPorIVA" style="cursor: pointer"
          >{{ leyendaTotales }} (click aquí)</span
        >
      </Table.Td>
    </Table.Tr> -->
      <template v-if="verTotalesPorTasa">
        <Table.Tr v-if="hayMonedaExtranjera">
          <Table.Td colspan="100%" class="text-center">
            Totales por tasa en moneda de origen

            <Table.t style="display: flex; justify-content: center">
              <Table.t
                v-for="tasa in totalesPorTasasOrigen"
                :key="tasa.tasa"
                class="text-left m-5"
              >
                <div class="flex">
                  <Table.t class="flex">
                    <b class="m-2"
                      >Tasa {nombreTasa}
                      <!-- {{ tasasStore.getTasaIVAById(tasa.tasa)?.nombre }}:-->
                    </b>
                  </Table.t>
                  <div>
                    <Table.t v-for="moneda in tasa.monedas">
                      <Table.Tr>
                        Importe: $
                        <!-- {{
                        monedasStore.getMonedaById(moneda.moneda)?.simbolo
                      }} -->
                        {{ numeroFormateado(moneda.importe) }}
                      </Table.Tr>
                      <Table.Tr>
                        IVA: $
                        <!-- {{
                        monedasStore.getMonedaById(moneda.moneda)?.simbolo
                      }} -->
                        {{ numeroFormateado(moneda.montoIVA) }}
                      </Table.Tr>
                    </Table.t>
                  </div>
                </div>
              </Table.t>
            </Table.t>
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td colspan="100%" class="text-center" v-if="verTotalesPorTasa">
            Totales por tasa en moneda nacional
            <div class="flex justify-center" v-if="verTotalesPorTasa">
              <template
                v-for="tasa in totalesPorTasasNacional"
                :key="tasa.tasa"
              >
                <div class="text-center">
                  <b class="m-2"
                    >Tasa {nombretasa}
                    <!-- {{ tasasStore.getTasaIVAById(tasa.tasa)?.nombre }}: -->
                  </b>
                </div>
                <div class="m-5 flex">
                  <div>
                    <div class="flex">
                      Importe: $ {{ numeroFormateado(tasa.importe) }}
                    </div>
                    <div class="flex" v-if="tasa.montoIVA != 0">
                      IVA: $ {{ numeroFormateado(tasa.montoIVA) }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td colspan="100%" class="text-center" v-if="verTotalesPorTasa">
            Totales en moneda nacional
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td class="text-center">
            Importe sin IVA: $ {{ numeroFormateado(importeTotalSinIVA) }}
          </Table.Td>
          <Table.Td class="text-center">
            IVA: $ {{ numeroFormateado(importeIVAtotal) }}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td colspan="100%"> &nbsp; </Table.Td>
        </Table.Tr>
      </template>
    </Table>
  </div>
</template>
